<template>
	<div class="indicator_chart bg-white">
		<div v-if="xAxis.length>0" class="container" :id="container"></div>
		<div
			class="none_style "
			:class="{
			'displayNone':xAxis.length > 0
		}"
		></div>
	</div>
</template>

<script>
export default {
    name: 'indicatorChart',
    props: {
        container: {
            type: String,
            default: 'container'
        }
    },
    data: () => ({
        xAxis: [],
        tooltip: {
            data: {},
            style: {}
        }
    }),
    methods: {
        // 启动绘制
        start (detail) {
            this.xAxis = detail.xAxis
            this.$nextTick(() => {
                this.startDraw(detail)
            })
        },
        startDraw (detail) {
            if (this.xAxis.length === 0) {
                return
            }
            let myChart = this.$echarts.init(document.getElementById(this.container))
            window.addEventListener('resize', function () {
                myChart.resize()
            })
            // 指定图表的配置项和数据
            let option = {
                title: {
                    show: false
                },
                tooltip: {
                    ...detail.tooltip,
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                legend: {
                    show: false
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    // show: false,
                    axisTick: {
                        show: false // 隐藏x轴刻度
                    },
                    axisLabel: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#AAAAAA'
                        }
                    },
                    // prettier-ignore
                    data: detail.xAxis
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}',
                        fontSize: 8,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#AAAAAA'
                        }
                    },
                    axisPointer: {
                        snap: true
                    },
                },
                series: detail.datas.map(v => ({
                    ...v,
                    type: v.type ? v.type : 'line',
                    smooth: true,
                    itemStyle: {
                        ...v.itemStyle,
                        color: v.color
                    },
                    lineStyle: {
                        ...v.lineStyle,
                        color: v.color
                    },
                    markArea: detail.markArea ? detail.markArea : {}
                })),
                grid: detail.grid ? detail.grid : { x: 0, y: 10, x2: 10, y2: 5, containLabel: true }
            }
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option)
        }
    }
}
</script>

<style scoped lang="less">
.indicator_chart {
	border-radius: 16px;
	.container {
		width: 100%;
		height: 300px;
	}
	.more {
		height: 100%;
		display: flex;
		align-items: center;
		font-family: PingFangSC-Regular;
		font-size: 26px;
		font-weight: normal;
		line-height: 31px;
		color: @gray-9;
		img {
			width: 14px;
			margin-left: 12px;
			vertical-align: middle;
		}
	}
	.none_style {
		width: 100%;
		height: 246px;
		background-image: url('../../../assets/img/none-charts.png');
		background-size: 100% 100%;
		margin-top: 20px;
	}

	.displayNone {
		display: none;
	}
}
</style>

<style lang="less">
.indicator_chart {
	.van-empty {
		padding-top: 100px;
		.van-empty__image {
			height: initial;
		}
		.van-empty__description {
			font-family: PingFangSC-Regular;
			font-size: 26px;
			font-weight: normal;
			line-height: 31px;
			color: #8f959e;
		}
	}
}
</style>
